module.exports = __webpack_public_path__ + "system/img/no-widget-hint.d89b5b0b.png";